import React, { FC } from 'react';
import { HeatmapSectorData } from './utils';
import { UsageZone } from './usageZone';

export const HeatmapSectorsThirds: FC<HeatmapSectorData> = ({
  averageCount,
  totalEuh,
}) => {
  const max = Math.max(...averageCount[0]);

  return (
    <div className="grid h-full grid-cols-3 gap-1">
      <UsageZone value={averageCount[0][0]} totalEuh={totalEuh} max={max} />
      <UsageZone value={averageCount[0][1]} totalEuh={totalEuh} max={max} />
      <UsageZone value={averageCount[0][2]} totalEuh={totalEuh} max={max} />
    </div>
  );
};
